// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectUserwfdPageLoading,
  selectUserwfdShowInitWaitingMessage,
  selectUserwfdsInStore,
} from '../_selectors/userwfd.selectors';

export class UserwfdDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectUserwfdPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectUserwfdShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectUserwfdsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
